import React from "react";
import USER_AVATAR from "../../assets/images/avatars/avatar.png";

import { useDispatch, useSelector } from "react-redux";
import { logout, resetAuth } from "../../redux/slice/auth/authSlice";
import { resetOffices } from "../../redux/slice/office/officeSlice";
import { resetStaffRecords } from "../../redux/slice/staff/staffSlice";
import { resetUsers } from "../../redux/slice/user/userSlice";
import { resetCommission } from "../../redux/slice/commission/commissionSlice";
import ChangePassword from "../modals/ChangePassword";
import { resetPolicy } from "../../redux/slice/policy/policySlice";
import { resetCustomers } from "../../redux/slice/customer/customerSlice";
import { resetChartOfAccountState } from "../../redux/slice/accounting/accountingSlice";
import { resetRolesStatus } from "../../redux/slice/roles/roleSlice";
import { resetDash } from "../../redux/slice/dash/dashSlice";
import { resetUnderwriting } from "../../redux/slice/underwriting/underwritingSlice";
import { resetWorkflow } from "../../redux/slice/workflow/workflowSlice";

const Topnav = () => {
  const { user } = useSelector((state) => state.auth);
  const { user: user_info } = user;
  const dispatch = useDispatch();

  const signOut = () => {
    dispatch(resetStaffRecords());
    dispatch(resetOffices());
    dispatch(resetPolicy());
    dispatch(resetAuth());
    dispatch(resetUsers());
    dispatch(resetCustomers());
    dispatch(resetChartOfAccountState());
    dispatch(resetRolesStatus());
    dispatch(resetCommission());
    dispatch(resetDash());
    dispatch(resetUnderwriting());
    dispatch(resetWorkflow());
    dispatch(logout(user_info.id));
  };
  return (
    <>
      {/* <!-- Topbar Start --> */}
      <div className='navbar-custom'>
        <ul className='list-unstyled topbar-menu float-end mb-0'>
          <li className='dropdown notification-list d-lg-none'>
            <a
              className='nav-link dropdown-toggle arrow-none'
              data-bs-toggle='dropdown'
              href='/'
              role='button'
              aria-haspopup='false'
              aria-expanded='false'
            >
              <i className='dripicons-search noti-icon'></i>
            </a>
            <div className='dropdown-menu dropdown-menu-animated dropdown-lg p-0'>
              <form className='p-3'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search ...'
                  aria-label="Recipient's username"
                />
              </form>
            </div>
          </li>

          {/* <!-- Dark Switch--> */}
          {/* <li className='dropdown pt-3'>
                    <input type="checkbox" id="switch7" data-switch="secondary"/>
                    <label htmlFor="switch7" data-on-label="" data-off-label="L"></label>  
                </li> */}

          {/* <li className="dropdown notification-list">
                    <a className="nav-link dropdown-toggle arrow-none" href="/">
                        <i className="dripicons-bell noti-icon"></i>
                        <span className="noti-icon-badge"></span>
                    </a>
                </li> */}

          <li className='dropdown notification-list'>
            <a
              className='nav-link dropdown-toggle nav-user arrow-none me-0'
              data-bs-toggle='dropdown'
              href='/'
              role='button'
              aria-haspopup='false'
              aria-expanded='false'
            >
              <span className='account-user-avatar'>
                <img src={USER_AVATAR} alt='user' className='rounded-circle' />
              </span>
              <span>
                <span className='account-user-name mt-1'>
                  {user?.user?.first_name} {user?.user?.last_name}
                </span>
              </span>
            </a>
            <div className='dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown'>
              {/* <!-- item--> */}
              <div className=' dropdown-header noti-title'>
                <h6 className='text-overflow m-0'>Welcome !</h6>
              </div>

              {/* <!-- item--> */}
              {/* <a href="/" className="dropdown-item notify-item">
                            <i className="mdi mdi-account-circle me-1"></i>
                            <span>My Account</span>
                        </a> */}

              {/* <!-- item--> */}
              <a
                href='/'
                className='dropdown-item notify-item'
                data-bs-toggle='modal'
                data-bs-target='#staticBackdrop2'
              >
                <i className='mdi mdi-account-edit me-1'></i>
                <span>Change Password</span>
              </a>

              {/* <!-- item--> */}

              <button onClick={signOut} className='dropdown-item notify-item'>
                <i className='mdi mdi-logout me-1'></i>
                <span>Logout</span>
              </button>
            </div>
          </li>
        </ul>
        <button className='button-menu-mobile open-left'>
          <i className='mdi mdi-menu'></i>
        </button>
        {/* <div className="app-search dropdown d-none d-lg-block">
                <form>
                    <div className="input-group">
                        <input type="text" className="form-control dropdown-toggle"  placeholder="Search..." id="top-search"/>
                        <span className="mdi mdi-magnify search-icon"></span>
                        <button className="input-group-text btn-primary" type="submit">Search</button>
                    </div>
                </form>

            </div> */}
      </div>
      {/* <!-- end Topbar --> */}
      <ChangePassword modal_id='staticBackdrop2' />
    </>
  );
};

export default Topnav;
